import { useNavigate, useLocation } from "react-router-dom";
import { setCurrentPage } from "../../../../redux/slices/bwvSlice";
import { useDispatch } from "react-redux";

const TabNav = ({ activeTab, setActiveTab, tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleTabClick = (tabName, param) => {
    setActiveTab(tabName);
    dispatch(setCurrentPage(1));
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", param);
    navigate(
      { pathname: location.pathname, search: searchParams.toString() },
      { replace: true }
    );
  };

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        marginTop: "12px",
        marginLeft: "2px",
        gap: "4px",
      }}
    >
      {tabs.map(({ name, param, badgeContent }) => (
        <h5
          key={name}
          style={{
            width: `${100 / tabs.length}%`,
            textAlign: "center",
            padding: "8px 0",
            cursor: "pointer",
            transition: "all 0.2s ease",
            backgroundColor: activeTab === name ? "var(--button-bg)" : "",
            color: activeTab === name ? "var(--white)" : "var(--letters)",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            border: "1px solid var(--theme-border)",
            position: "relative",
          }}
          onMouseOver={(e) => {
            if (activeTab !== name)
              e.target.style.backgroundColor = "var(--theme-lighter)";
          }}
          onMouseOut={(e) => {
            if (activeTab !== name)
              e.target.style.backgroundColor = "var(--white)";
          }}
          onClick={() => handleTabClick(name, param)}
        >
          {name}
          {badgeContent > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-10px",
                right: "10px",
                backgroundColor: "#d32f2f",
                color: "var(--white)",
                borderRadius: "50%",
                padding: "2px 6px",
                fontSize: "12px",
                lineHeight: "1",
              }}
            >
              {badgeContent}
            </span>
          )}
        </h5>
      ))}
    </div>
  );
};

export default TabNav;
